var newSliderSmallGamification = (function(){

    var response = [];

    function init(){
        $(document).ready( function(){

            if($(".new-slider-small-gamification").length){

                $(".input-lamp, .next-slide").on("click", function(){
                    var closestParent = $(".gamification-answer");
                    var dataOriginalQuestion = $(this).closest(closestParent).attr("data-original-question");
                    var dataBool = $(this).closest(closestParent).attr("data-bool");

                    updateResponse(dataOriginalQuestion, dataBool)

                    var dataAnswer = $(this).closest(closestParent).attr("data-answer");
                    var dataCorrectLabel = $(this).closest(closestParent).attr("data-correct-label");
                    var dataWrongLabel = $(this).closest(closestParent).attr("data-wrong-label");

                    var owl = $(this).closest(".new-slider-small-component .owl-carousel");
                    owl.trigger('next.owl.carousel');

                    //DYNAMIC LAST SLIDE RESPONSE
                    var totalGamificationSlides = $(".new-slider-small-component .owl-carousel .new-slider-small-gamification").length
                    var indexCurrentActiveSlide = $(".new-slider-small-component .owl-carousel .owl-item.active").index();

                    if(totalGamificationSlides == (indexCurrentActiveSlide+1)){
                        //-1 xk l'ultima slide non conta
                        handleDynamicGamificationLastSlide(totalGamificationSlides-1);
                    }

                    if(dataBool == dataAnswer){
                        $(".owl-item.active .answer-label #correct-img").removeClass("d-none");
                        $(".owl-item.active .answer-label .answer-title").html(dataCorrectLabel);
                    }else{
                        $(".owl-item.active .answer-label #wrong-img").removeClass("d-none");
                        $(".owl-item.active .answer-label .answer-title").html(dataWrongLabel);
                    }
                });

                $(".new-slider-small-gamification .go-back-section button.go-previous-slide").on("click", function(){
                    var dataOriginalQuestion = $(this).attr("data-original-question");
                    var dataBool = $(this).attr("data-bool");
                    updateResponse(dataOriginalQuestion, dataBool, true )
                    var owl = $(this).closest(".new-slider-small-component .owl-carousel");
                    owl.trigger('prev.owl.carousel');
                    
                })

            }else{
                return;
            }
        });
    }

    function handleDynamicGamificationLastSlide(totalSlidesNumber){
        var slidesTrue = totalSlidesNumber
        var majorityTrue = true;
        response.forEach((singleResponse) => {
            if(singleResponse.answer == 0){
                slidesTrue--;
            } 
        })
        if(slidesTrue/totalSlidesNumber < 0.5){
            majorityTrue = false; 
        }

        if(!majorityTrue){
            $(".new-slider-small-gamification .most-answer-true").addClass("d-none");
            $(".new-slider-small-gamification .most-answer-false").removeClass("d-none");

        }
        
        
    }

    function updateResponse(question, answer, goBack = false){

        response = response.filter((questionObject) => questionObject.question != question);

        if (!goBack) {
            newResponse = {
                "question" : question,
                "answer" : answer
            };

            response.push(newResponse); 
        }

        inputField = $(".customizable-contact-form input[name='form-json-data']").val(JSON.stringify(response))
        
    }

    return {init: init};

})(jQuery);